<template>
  <v-container fluid class="mt-4 mx-auto">
    <v-tabs v-model="selectedTab" class="client-admin-tabs">
      <v-tab v-for="item in tabs" :key="item._id" :value="item._id">
        <span class="tab-title"> {{ item.name }}</span>
      </v-tab>
    </v-tabs>
    <v-window v-model="selectedTab" class="client-admin-tabs">
      <v-window-item v-for="item in tabs" :key="item._id" :value="item._id">
        <ReferenceClusterScheme
          v-if="item._id === 'defaultClusters' && hasDefaultClustersEnabled"
        />
      </v-window-item>
    </v-window>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { get } from 'lodash';
import { useInternationalization } from '@/composables/use-internationalization';
import { useContextStore } from '@/stores/context';
import { useSnackbarStore } from '@/stores/snackbar';

export default {
  setup() {
    const { tkey } = useInternationalization('clientAdminPage');
    return { tkey };
  },

  data() {
    return {
      tabs: [],
      selectedTab: 0,
      clusterSchemes: [],
      selectedClusterSchemeName: '',
    };
  },

  computed: {
    ...mapState(useContextStore, ['getClientConfig']),

    hasDefaultClustersEnabled() {
      return get(this.getClientConfig, 'features.defaultClustersEnabled', false);
    },
  },

  async created() {
    await this.reset();
  },

  methods: {
    ...mapActions(useSnackbarStore, ['showSuccess', 'showError']),

    async reset() {
      if (this.hasDefaultClustersEnabled) {
        this.tabs.push({ _id: 'defaultClusters', name: this.tkey('defaultClusters') });
      }
    },
  },
};
</script>

<style lang="scss">
@import '@style/base/_variables.scss';

.client-admin-tabs {
  background-color: $rtls-white;
}
</style>
